import React from "react"
import TextArea from "@infotech/uikit-textarea"
import { withHandlers } from "recompact"
import styles from "./styles.css"

export default withHandlers({
  onChange: ({ input: { onChange } }) => value => {
    onChange(value)
  },
  onBlur: ({ input: { onBlur, value } }) => () => onBlur(value),
})(
  ({
    input: { value, placeholder },
    meta: { valid, error },
    options,
    className,
    ...restProps
  }) => (
    <div className={className}>
      <TextArea
        {...restProps}
        value={value}
        placeholder={
          placeholder || restProps.placeholder || `Введите значение...`
        }
        invalid={!valid}
        error={error}
        className={styles[`textarea-itself`]}
      />
    </div>
  ),
)
